/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginRequest as UserServiceContractLoginRequest } from '../../models/UserService/Contract/login-request';
import { LoginResponse as UserServiceContractLoginResponse } from '../../models/UserService/Contract/login-response';

export interface ApiLoginCheckLoginPost$Params {

/**
 * Interface language
 */
  lang?: string;
  
    /**
     * User authorization request
     */
    body?: UserServiceContractLoginRequest
}

export function apiLoginCheckLoginPost(http: HttpClient, rootUrl: string, params?: ApiLoginCheckLoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UserServiceContractLoginResponse>> {
  const rb = new RequestBuilder(rootUrl, apiLoginCheckLoginPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserServiceContractLoginResponse>;
    })
  );
}

apiLoginCheckLoginPost.PATH = '/api/Login/CheckLogin';
